<template>
<div class="animated fadeIn">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <b-tabs v-model="tabIndex">
            <b-tab :title="$t('RECENTACTIVITY')">
              <recentactivitywin v-bind:storeId="storeId" v-bind:tabIndex="tabIndex"></recentactivitywin>
            </b-tab>
            <b-tab :title="$t('EMPLOYEES')" v-if="(globals.groupId != 4) ? true : false">
              <employeeswin v-bind:storeId="storeId" v-bind:tabIndex="tabIndex"></employeeswin>
            </b-tab>
            <b-tab :title="$t('SCHEDULES')" v-if="(globals !== undefined && globals.acl !== undefined && globals.acl.Schedual && globals.acl.Schedual.insertAction) ? true : false">
              <schedulewin v-bind:storeId="storeId" v-bind:tabIndex="tabIndex"></schedulewin>
            </b-tab>
            <b-tab :title="$t('REPORTS')">
              <reportswin v-bind:storeId="storeId" v-bind:tabIndexParent="tabIndex" v-bind:childTab="childTab"></reportswin>
            </b-tab>
            <b-tab :title="$t('DATEEXCEPTIONS')" v-if="(globals !== undefined && globals.acl !== undefined && globals.acl.StoreDateException && globals.acl.StoreDateException.insertAction) ? true : false">
              <dateexceptionswin v-bind:storeId="storeId" v-bind:tabIndex="tabIndex"></dateexceptionswin>
            </b-tab>
            <b-tab :title="$t('DPS')">
              <dpswin v-bind:storeId="storeId" v-bind:tabIndex="tabIndex"></dpswin>
            </b-tab>
            <b-tab :title="$t('DAILYSALES')">
              <dailysaleswin v-bind:storeId="storeId" v-bind:tabIndex="tabIndex"></dailysaleswin>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'

import RecentActivityWin from './storedetails/RecentActivityWin'
import EmployeesWin from './storedetails/employe/EmployeesWin'
import ScheduleWin from './storedetails/schedule/ScheduleWin'
import DateExceptionsWin from './storedetails/dateexception/DateExceptionsWin'
import DpsWin from './storedetails/dps/Win'
import DailySalesWin from './storedetails/dailysales/Win'
import ReportsWin from './storedetails/reports/Win'

export default
{
  name: 'DetailsWin',
  components:
  {
    recentactivitywin: RecentActivityWin,
    employeeswin: EmployeesWin,
    schedulewin: ScheduleWin,
    dateexceptionswin: DateExceptionsWin,
    dpswin: DpsWin,
    dailysaleswin: DailySalesWin,
    reportswin: ReportsWin
  },
  data()
  {
    var me = this;
    return {
      storeId: null,
      tabIndex: 0,
      childTab: 0
    }
  },
  async created()
  {
    var me = this;
    me.storeId = me.$route.params.storeId
  },
  methods:
  {

  },
  watch:
  {

  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
